<template>
    <div class="point-info-tooltip">
        <div class="point-info-tooltip-title">
            <div class="content-nav-item" v-if="currentMember">
                <span style="font-size: 16px; color: #49f0fdff">{{
                    currentMember.userName || '--'
                }}</span>
                <div class="content-nav-item-tag">{{ currentMember.postLabel || '--' }}</div>
            </div>
            <div class="content-nav-item" v-else>
                <span style="font-size: 16px; color: #49f0fdff">--</span>
            </div>
            <div class="content-nav-item" v-if="currentMember">
                <div class="content-nav-item-tag" style="margin-left: 10px">
                    {{ currentMember.statusLabel || '请假' }}
                </div>
            </div>
            <div class="el-icon-close" @click="showPointLeaderTipFn(false)"></div>
        </div>
        <div class="content">
            <div class="content-nav">
                <div class="content-nav-item" v-if="currentMember">
                    <span>电话</span>
                    {{ currentMember.phone || '--' }}&nbsp;
                    <div
                        class="content-nav-item-tag active"
                        style="cursor: pointer"
                        @click="handleChatButtonClick"
                    >
                        即时通讯
                    </div>
                </div>
                <div class="content-nav-item" v-else>
                    <span>电话</span>
                    --&nbsp;
                    <div
                        class="content-nav-item-tag active"
                        style="cursor: pointer"
                        @click="handleChatButtonClick"
                    >
                        即时通讯
                    </div>
                </div>
                <div class="content-nav-item">
                    <span>所属</span>
                    {{ (selectUserObj && selectUserObj.name) || '--' }}
                </div>

                <div class="content-nav-item" v-if="currentMember">
                    <span>位置</span>{{ currentMember.location || '--' }}&nbsp;
                </div>
                <div class="content-nav-item" v-else>
                    <span>位置</span>--&nbsp;
                </div>
                <div v-if="showTime" class="content-nav-item">
                    <span>距离事发点</span>{{ distance || (currentMember && currentMember.distance) || '--' }}
                </div>
                <div v-if="showTime" class="content-nav-item">
                    <span>到达目的地时长</span>{{ duration || (currentMember && currentMember.duration) || '--' }}
                </div>
                <div class="content-nav-item" v-if="currentMember">
                    <span>数据更新时间</span>{{ currentMember.clockTime || '--' }}
                </div>
                <div class="content-nav-item" v-else>
                    <span>数据更新时间</span>--
                </div>
            </div>
            <div class="content-system" v-if="carList && carList.length">
                <div class="content-system-left">
                    <span style="position: absolute; left: 0; top: 4px">救援车</span>
                </div>
                <div class="content-system-right">
                    <div style="margin-bottom: 10px" v-for="item in carList" :key="item.carId">
                        <div class="content-nav-item" style="line-height: 17px">
                            <span>车型</span>
                            {{ item.carBrand }} {{ item.model }} {{ item.name }}&nbsp;&nbsp;
                        </div>
                        <div class="content-nav-item">
                            <span>续航</span>
                            约 {{ item.battery || '--' }} KM
                            <span style="padding-left: 10px">状态</span>
                            <div class="content-nav-item-tag">{{ item.status || '--' }}</div>
                        </div>
                        <img
                            style="width: 104px; height: 78px; margin: 5px 0 0"
                            :src="item.url"
                        />
                    </div>
                </div>
            </div>
            <template v-if="droneList && droneList.length">
                <div :key="item.vehicleId" class="content-system" v-for="item in droneList">
                    <div class="content-system-left">
                        <span style="position: absolute; left: 0; top: 4px">无人机</span>
                    </div>
                    <div class="content-system-right">
                        <div class="content-nav-item">
                            <span>型号</span>
                            <div>
                                {{ item.model }}&nbsp;&nbsp;
                                <span class="content-nav-item-tag" v-if="item.status">
                                    {{ item.status }}
                                </span>
                            </div>
                        </div>
                        <div class="content-nav-item">
                            <span>电量</span>
                            <img
                                :src="status.wing_battery"
                                alt=""
                                v-for="(status, index) in batteryStatus(item.battery)"
                                :key="index"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <div class="content-system" v-if="mountList && mountList.length">
                <div class="content-system-left">
                    <span style="position: absolute; left: 0; top: 4px">挂载</span>
                </div>
                <div class="content-system-right">
                    <div v-for="item in mountList" :key="item.deviceId">
                        <div class="content-nav-item">
                            <span>类型</span>
                            {{ item.name }}&nbsp;&nbsp;
                            <div class="content-nav-item-tag" v-if="item.deviceStatus">
                                {{ item.deviceStatus }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page_left" v-show="selectUserObj && selectUserObj.memberList && selectUserObj.memberList.length > 1" @click="pagePrv"></div>
        <div class="page_right" v-show="selectUserObj && selectUserObj.memberList && selectUserObj.memberList.length > 1" @click="pageNext"></div>
    </div>
</template>

<script>

export default {
    name: 'PointLeaderInfoTooltip',
    inject: [],
    props: {
        selectUserObj: Object,
        distance: {
            type: String,
        },
        duration: {
            type: String,
        },
        showPointLeaderTipFn: {
            type: Function,
            default: (val) => val,
        },
        dangerObj: {
            type: [String, Object],
        },
    },
    data() {
        return {
            iconBattery: {
                wing_battery_1: require('../images/icon_battery-1.png'),
                wing_battery_2: require('../images/icon_battery-2.png'),
                wing_battery_3: require('../images/icon_battery-3.png'),
                wing_battery_4: require('../images/icon_battery-4.png'),
            },
            chatWindow: false,
            page: 0,
        };
    },
    computed: {
        showTime() {
            return (this.selectUserObj && this.selectUserObj.caseId) || this.dangerObj;
        },
        mountList() {
            return this.selectUserObj ? this.selectUserObj.mountList : [];
        },
        carList() {
            return this.selectUserObj ? this.selectUserObj.carList : [];
        },
        droneList() {
            return this.selectUserObj ? this.selectUserObj.droneList : [];
        },
        currentMember() {
            if (!this.selectUserObj || !this.selectUserObj.memberList || !this.selectUserObj.memberList[this.page]) {
                return null;
            }
            console.log('this.selectUserObj.memberList[this.page]', this.selectUserObj.memberList[this.page]);
            return this.selectUserObj.memberList[this.page];
        },
    },
    methods: {
        pagePrv() {
            if (!this.selectUserObj || !this.selectUserObj.memberList || this.page <= 0) return;
            this.page--;
        },
        pageNext() {
            if (!this.selectUserObj || !this.selectUserObj.memberList || this.page >= this.selectUserObj.memberList.length - 1) return;
            this.page++;
        },
        batteryStatus(statusArr) {
            let batteryArr = [];
            if (!statusArr) return batteryArr;
            let statusArrs = statusArr ? statusArr.split(',') : [];
            statusArrs.forEach((item) => {
                switch (true) {
                    case item >= 75:
                        batteryArr.push({ wing_battery: require('../images/wing-battery-4.png') });
                        break;
                    case item >= 50:
                        batteryArr.push({ wing_battery: require('../images/wing-battery-3.png') });
                        break;
                    case item >= 25:
                        batteryArr.push({ wing_battery: require('../images/wing-battery-2.png') });
                        break;
                    case item >= 0:
                        batteryArr.push({ wing_battery: require('../images/wing-battery-1.png') });
                        break;
                    default:
                        break;
                }
            });
            return batteryArr;
        },
        handleChatButtonClick() {
            this.$emit('closePointLeaderTipFn');

            let personInfo = this.currentMember;
            if (personInfo) {
                const account = personInfo.account;
                const imManager = this.$root.$imManager;
                if (imManager) {
                    let option = {
                        targetUser: account,
                        nickName: personInfo.name || personInfo.personnelName,
                        avatar: personInfo.photo,
                    };

                    imManager.createSingleChat(option);
                    imManager._vm.show = true;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep ::-webkit-scrollbar {
    width: 5px;
    height: 0;
}
::v-deep ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.5);
}
.point-info-tooltip {
    position: relative;
    width: 300px;

    .point-info-tooltip-title {
        display: flex;
        background: #1a47a4;
        padding: 10px;
        font-size: 16px;
        color: #49f0fdff;
        border: 1px solid #49f0fd;
        .el-icon-close {
            position: absolute;
            right: 9px;
            cursor: pointer;
            top: 15px;
            color: #fff;
            font-size: 20px;
        }
    }

    .content-title {
        font-size: 18px;
        color: #49f0fdff;
        line-height: 55px;
        text-align: center;
    }
    .content {
        height: 360px;
        overflow-y: auto;
        .content-nav {
            padding: 10px;
            background: #1a47a4;
        }
        .content-system {
            display: flex;
            flex-wrap: wrap;
            padding: 10px;
            border-top: 1px solid #1a47a4;
            .content-system-left {
                position: relative;
                width: 60px;
                font-size: 16px;
                color: #fff;
            }
            .content-system-right {
                flex: 1;
            }
        }
    }
    .content-nav-item {
        display: flex;
        color: #fff;
        font-size: 14px;
        line-height: 28px;
        ::v-deep .el-avatar {
            margin-right: 10px;
        }
        span {
            padding-right: 10px;
            min-width: 28px;
            color: rgba(255, 255, 255, 0.5);
        }
        img {
            width: 16px;
            height: 16px;
            margin-top: 5px;
        }
        .content-nav-item-tag {
            height: 20px;
            margin-top: 2px;
            padding: 4px 5px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #49f0fd;
            text-align: center;
            color: #49f0fdff;
            line-height: 10px;
            &.active {
                color: #10163aff;
                background: #49f0fd;
            }
        }
    }
    .page_left,
    .page_right {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size: 30px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;
    }
    .page_left {
        background: url('../images/icon-page-left.png') center no-repeat;
        &:hover {
            background: url('../images/icon-page-left-active.png') center no-repeat;
        }
    }
    .page_right {
        right: 0;
        background: url('../images/icon-page-right.png') center no-repeat;
        &:hover {
            background: url('../images/icon-page-right-active.png') center no-repeat;
        }
    }
}
</style>
